import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "breadcrumb-switcher-menu__label" };
const _hoisted_2 = ["href"];
const _hoisted_3 = {
    key: 0,
    class: "breadcrumb-switcher-menu__empty"
};
import { computed, ref, watch } from "vue";
import { useScroll } from "@vueuse/core";
import { normalizeSearchTerm } from "@/common/helpers/search";
// Components
import DropdownMenu from "@/common/components/DropdownMenu.vue";
import SearchInput from "@/common/components/SearchInput.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'BreadcrumbSwitcherMenu',
    props: {
        options: {},
        optionKey: {},
        isCurrent: {},
        filterFct: {},
        triggerLabel: {},
        headerLabel: {},
        headerHref: {},
        searchPlaceholder: {},
        noResultsLabel: {},
        searchThreshold: { default: 10 },
        menuWidth: { default: 340 },
        headerClass: { default: undefined },
        listClass: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const searchTerm = ref("");
        const optionsEl = ref();
        const isOpen = ref(false);
        watch(isOpen, (open) => {
            if (!open)
                searchTerm.value = "";
        });
        const { arrivedState } = useScroll(optionsEl);
        const showTopFade = computed(() => !arrivedState.top);
        const showSearch = computed(() => props.options.length > props.searchThreshold);
        const filteredOptions = computed(() => props.options.filter((option) => props.filterFct(option, searchTerm.value)));
        const showNoResults = computed(() => normalizeSearchTerm(searchTerm.value) !== "" && filteredOptions.value.length === 0);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DropdownMenu, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((isOpen).value = $event)),
                class: "breadcrumb-switcher-menu",
                "auto-close": false,
                "menu-width": __props.menuWidth,
                "menu-class": "breadcrumb-switcher-menu__menu"
            }, {
                button: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.triggerLabel), 1)
                ]),
                menu: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(['breadcrumb-switcher-menu__header', __props.headerClass]),
                        role: "none"
                    }, [
                        _createElementVNode("a", {
                            role: "menuitem",
                            class: "rec-dropdown-menu__item",
                            href: __props.headerHref
                        }, _toDisplayString(__props.headerLabel), 9, _hoisted_2),
                        _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "rec-dropdown-menu__divider" }, null, -1)),
                        (showSearch.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "breadcrumb-switcher-menu__search",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                            }, [
                                _createVNode(SearchInput, {
                                    modelValue: searchTerm.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                                    placeholder: __props.searchPlaceholder,
                                    "clear-on-esc": ""
                                }, null, 8, ["modelValue", "placeholder"])
                            ]))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        ref_key: "optionsEl",
                        ref: optionsEl,
                        class: _normalizeClass([
                            'breadcrumb-switcher-menu__files',
                            __props.listClass,
                            { 'breadcrumb-switcher-menu__files--scrolled': showTopFade.value }
                        ]),
                        role: "none"
                    }, [
                        (showNoResults.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.noResultsLabel), 1))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                            return _renderSlot(_ctx.$slots, "option", {
                                option: option,
                                current: __props.isCurrent(option)
                            }, undefined, undefined, __props.optionKey(option));
                        }), 128))
                    ], 2)
                ]),
                _: 3
            }, 8, ["modelValue", "menu-width"]));
        };
    }
});
